import styled from "@emotion/styled";
import { Button, TertiaryText, Theme } from "@silvertours/front-shared";
var BenefitsWrapper = /*#__PURE__*/ styled("div", {
    target: "e1rqbipk0"
})("color:", function(param) {
    var theme = param.theme;
    return theme.color.natural100;
}, ";justify-content:space-between;margin-top:", function(param) {
    var theme = param.theme;
    return theme.spacing[40];
}, ";margin-bottom:", function(param) {
    var theme = param.theme;
    return theme.spacing[40];
}, ";");
var BenefitText = /*#__PURE__*/ styled(TertiaryText, {
    target: "e1rqbipk1"
})("padding-left:10px;font-weight:400;text-transform:none;");
var BenefitWrapper = /*#__PURE__*/ styled("div", {
    target: "e1rqbipk2"
})("display:flex;padding:5px 0;");
var ImageWrapper = /*#__PURE__*/ styled("div", {
    target: "e1rqbipk3"
})("padding:10px;text-align:center;");
var JoinButton = /*#__PURE__*/ styled(Button, {
    target: "e1rqbipk4"
})("margin:0.5rem 0 1.5rem;");
var LinkWrapper = /*#__PURE__*/ styled("p", {
    target: "e1rqbipk5"
})("margin:1rem 0 0;");
var MembershipWrapper = /*#__PURE__*/ styled("div", {
    target: "e1rqbipk6"
})("display:flex;flex-direction:column;padding:0 1rem;", Theme.mq("lg"), "{padding:1.5rem 1rem;}");
export { BenefitsWrapper, BenefitText, BenefitWrapper, ImageWrapper, JoinButton, LinkWrapper, MembershipWrapper };
